<template lang="pug">
  .whb-chart-wrapper
    canvas(ref="canvas")

</template>

<script>
import Chart from 'chart.js'
import anotations from 'chartjs-plugin-annotation'
import { floatToHoursMinsString } from 'src/utils'

export default {
  name: 'WhbChart',
  props: {
    employee: {type: Object, required: true}
  },
  watch: {
    'employee.id': function () {
      this.fetchData()
    }
  },
  created () {
    this.fetchData()
  },
  mounted () {
    this.$nextTick(this.mountChart)
  },
  data () {
    return {
      chart: null,
      curentPeriod: null,
      labels: [],
      accumulated: [],
      compensated: [],
      totalAccumulatedCompensated: [],
      //
      accumulatedValues: [],
      balance: [],
      givenhours: [],
      compensatedValues: [],
      receivedhours: []
    }
  },
  methods: {
    async fetchData () {
      const result = await this.$API.whbWindowManagement.get({employeeId: this.employee.id})

      if (result.status === 204) {
        this.accumulatedValues = []
        this.balance = []
        this.givenhours = []
        this.compensatedValues = []
        this.receivedhours = []
        return
      }

      this.curentPeriod = result.data.success.curentPeriod
      this.labels = result.data.success.data.labels

      this.accumulatedValues = result.data.success.data.accumulatedValues
      this.balance = result.data.success.data.balance
      this.givenhours = result.data.success.data.givenhours

      this.compensatedValues = result.data.success.data.compensatedValues
      this.receivedhours = result.data.success.data.receivedhours

      this.mountChart()
    },
    mountChart () {
      if (this.chart) {
        this.chart.destroy()
      }

      const max = Math.max(...this.accumulatedValues, ...this.givenhours) * 1.5
      const min = Math.min(...this.compensatedValues, ...this.receivedhours, -(max * 0.3)) * 1.5

      this.chart = new Chart(this.$refs.canvas, {
        type: 'bar',
        plugins: [anotations],
        data: {
          labels: this.labels,
          datasets: [
            {
              label: 'balanço',
              backgroundColor: this.$store.getters['visual'].colors.colorInfo,
              borderWidth: 1,
              data: this.balance,
              xAxisID: 'bar-x-axis1',
              yAxisID: 'bar-y-axis2'
            },
            {
              label: 'horas acumuladas compensadas',
              borderWidth: 1,
              backgroundColor: this.$store.getters['visual'].colors.colorDanger,
              data: this.givenhours,
              xAxisID: 'bar-x-axis1',
              yAxisID: 'bar-y-axis2'
            },
            {
              label: 'horas acumuladas',
              // backgroundColor: this.$store.getters['visual'].colors.colorInfo,
              backgroundColor: 'rgba(0, 162, 181, 0.1)',
              borderWidth: 1,
              data: this.accumulatedValues,
              xAxisID: 'bar-x-axis2'
            },
            {
              label: 'horas acumuladas pagas',
              borderWidth: 1,
              backgroundColor: this.$store.getters['visual'].colors.colorDangerHover,
              data: this.receivedhours,
              xAxisID: 'bar-x-axis1'
            },
            {
              label: 'horas compensadas',
              backgroundColor: this.$store.getters['visual'].colors.colorDanger,
              borderWidth: 1,
              data: this.compensatedValues,
              xAxisID: 'bar-x-axis2'
            }
          ]
        },
        options: {
          maintainAspectRatio: false,
          responsive: true,
          legend: {
            position: 'right'
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                let label = data.datasets[tooltipItem.datasetIndex].label || ''
                if (label) {
                  label += ': '
                }
                label += floatToHoursMinsString(tooltipItem.yLabel)
                return label
              }
            }
          },
          scales: {
            xAxes: [
              {
                id: 'bar-x-axis2',
                stacked: true,
                categoryPercentage: 0.4,
                barPercentage: 1
              },
              {
                display: false,
                stacked: true,
                id: 'bar-x-axis1',
                type: 'category',
                categoryPercentage: 0.4,
                barPercentage: 0.5,
                gridLines: {
                  display: false,
                  offsetGridLines: true
                },
                offset: true
              }
            ],
            yAxes: [
              {
                id: 'bar-y-axis1',
                stacked: false,
                ticks: {
                  // this adds a 'padding' from the heighest value from top of the chart
                  min,
                  max,
                  callback: floatToHoursMinsString
                },
                padding: 50,
                gridLines: {
                  display: true
                }
              },
              {
                id: 'bar-y-axis2',
                display: false,
                stacked: true,
                ticks: {
                  // this adds a 'padding' from the heighest value from top of the chart
                  min,
                  max
                },
                padding: 50,
                gridLines: {
                  display: false
                }
              }
            ]
          },
          annotation: {
            annotations: [
              {
                type: 'line',
                mode: 'vertical',
                scaleID: 'bar-x-axis1',
                value: this.curentPeriod,
                borderColor: this.$store.getters['visual'].colors.colorPrimary,
                borderWidth: 1,
                borderDash: [10, 5],
                borderDashOffset: 10,
                label: {
                  content: 'hoje',
                  fontColor: this.$store.getters['visual'].colors.colorPrimaryContrast,
                  fontSize: 16,
                  enabled: true,
                  backgroundColor: this.$store.getters['visual'].colors.colorPrimary,
                  position: 'top',
                  yPadding: 2
                }
              }
            ]
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.whb-chart-wrapper {
  display: grid;
  height: 100%;

  canvas {
    height: 100%;
  }

  h3 {
    text-align: center;
  }
}
</style>
